export default __webpack_public_path__ + "static/banner-c74e0456b5d95d86eada18f873689843.jpg";